import React from 'react';
import { colors } from '~/layout';
import { Badge } from './styles';

type Props = {
  status: string;
};

export default function StatusBadge({ status }: Props) {
  let color;

  switch (status) {
    case '0':
      // Idle
      color = `${colors.green01}`;
      break;
    case '1':
      // In use
      color = `${colors.red03}`;
      break;
    case '2':
      // Busy
      color = `${colors.red03}`;
      break;
    case '4':
      // Unavailable
      color = `${colors.lightGray06}`;
      break;
    case '8':
      // Ringing
      color = `${colors.yellow01}`;
      break;
    case '16':
      // On hold
      color = `${colors.red03}`;
      break;
    default:
      color = `${colors.lightGray06}`;
      break;
  }

  return <Badge color={color} />;
}
